import React from "react";
import salary from "../assets/images/icons/salary.svg";
import controls from "../assets/images/icons/GuarenteedPlacement.svg";
import grade_Deputy from "../assets/images/icons/DptManager.svg";
import relationship from "../assets/images/icons/relationship_Manager.svg";
const PlacementSalaryComponent = () => {
  return (
    <>
      <section className="JobPlacementSalary" id="scrolljobplace">
        <div className="container">
          <h2 className="title">Job placement and salary</h2>
          <div className="row justify-content-evenly my-md-5 my-4">
            <div className="col-md-12 m-auto">
              <div className="row">
                <div className="col-md-3">
                  <div className="jbSalaray h-100">
                    <div>
                      <img
                        src={salary}
                        alt="salary"
                        width="60px"
                        height="60px"
                      />
                    </div>
                    <div className="">
                      <p>
                        Salary (CTC){" "}
                        <span style={{ whiteSpace: "nowrap" }}>
                          up to ₹5 Lakh
                        </span>{" "}
                        depending on the location of posting
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="jbSalaray h-100">
                    <div>
                      <img
                        src={controls}
                        alt="placement"
                        width="60px"
                        height="60px"
                      />
                    </div>
                    <div className="">
                      <p>
                        Guaranteed placement with the Bank on successful
                        completion of the programme
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="jbSalaray h-100">
                    <div className="">
                      <img
                        src={grade_Deputy}
                        alt="grade"
                        width="60px"
                        height="60px"
                      />
                    </div>
                    <div className=" m-top">
                      <p>Starting grade Deputy Manager Band 1</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="jbSalaray border-0 h-100">
                    <div className="">
                      <img
                        src={relationship}
                        alt="relationship"
                        width="60px"
                        height="60px"
                      />
                    </div>
                    <div className=" m-top">
                      <p>Sales and relationship management role</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-3 mx-md-auto">
                  <div className="jbSalaray border-0 h-100">
                    <div className="">
                      <img
                        src={salary}
                        alt="salary"
                        width="60px"
                        height="60px"
                      />
                    </div>
                    <div className=" m-top">
                      <p>
                        A stipend of ₹18,000 per month will be paid during the
                        programme.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default PlacementSalaryComponent;
